import styled, { css } from 'styled-components';

import YatMagnetism from '@pkg/components/Sections/Profile/Magnetism';

import { ButtonIcon } from '../ButtonIcon/ButtonIcon';

export type position = 'left' | 'right';

type Props = {
    $absolutelyPosition?: position;
};

const BACK_BUTTON_BASE = css<Props>`
    ${({ $absolutelyPosition }) =>
        $absolutelyPosition &&
        css`
            position: absolute;
            top: 0;
            z-index: 2;

            ${$absolutelyPosition === 'left'
                ? css`
                      left: 0;
                  `
                : css`
                      right: 0;
                  `}
        `}
`;

export const StyledYatButton = styled(ButtonIcon)<Props>`
    ${BACK_BUTTON_BASE}
`;

export const StyledYatMagnetism = styled(YatMagnetism)<Props>`
    ${BACK_BUTTON_BASE}
`;
